import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaDataPagamento = (): TabelaColuna => ({
  Chave: 'dataPagamento',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.dataLocaleString(linha.dataPagamento)}</span>
  ),
  RenderizarCabecalho: () => <div style={{ width: 90 }}>Data Pagamento</div>
})
